export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto flex flex-col lg:flex-row items-center gap-10">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              随时随地 · 移动追剧
            </h2>
            <p className="text-foreground-600 text-base leading-relaxed mb-6">
              老子影视网完美适配手机浏览器，无需下载App即可享受流畅的<strong>电视剧在线</strong>观看体验。
              通勤路上、午休时间、睡前放松，随时随地打开浏览器就能追<strong>最新电视剧</strong>，
              <strong>高清画质不缓冲</strong>，追剧从未如此便捷。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-checkbox-circle-fill text-accent-500 text-lg"></i>
                即开即看，无需下载
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-checkbox-circle-fill text-accent-500 text-lg"></i>
                流量优化，省流量播放
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-checkbox-circle-fill text-accent-500 text-lg"></i>
                全平台浏览器兼容
              </div>
            </div>
          </div>
          <div className="shrink-0">
            <div className="relative w-[240px] h-[480px] md:w-[260px] md:h-[520px] rounded-3xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20clean%20mobile%20phone%20mockup%20screen%20displaying%20a%20Chinese%20drama%20streaming%20interface%20with%20warm%20crimson%20and%20gold%20theme%20colors%2C%20drama%20poster%20thumbnails%20in%20a%20grid%20layout%2C%20modern%20UI%20design%2C%20clean%20typography%2C%20minimalist%20aesthetic%2C%20soft%20lighting%20on%20device%20frame&width=520&height=1040&seq=app-mockup-laozi&orientation=portrait"
                alt="老子影视网移动端追剧界面预览"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}